module.exports = __webpack_public_path__ + "static/group-image2-3133ab7c2425148f742652d17b34714a.jpg";